import type { RootState } from 'state';

function getStaticRoutesVisibleModel(state: RootState): boolean {
  const { visibleModel } = state.staticRoutes;

  return visibleModel;
}

export default getStaticRoutesVisibleModel;
